export default class RunStatus {
  static PENDING = 'PENDING';
  static RUNNING = 'RUNNING';
  static STOPPED = 'STOPPED';
  static EXITED = 'EXITED';
}
